/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Header1 from "ui/kit/typography/Header1";
import Body from "ui/kit/typography/Body";
import ContentWrapper from "ui/common/ContentWrapper";

const RootOnWaitlist: React.FC = () => {

    return (
        <ContentWrapper>
            <Header1>You're on the waitlist</Header1>
            <Body>Due to high demand, we are limiting the number of people who can access our service. You will receive
                an email when you are off the waitlist.</Body>
        </ContentWrapper>
    )
}

export default RootOnWaitlist;